export type RoleType = 'admin' | 'manager' | 'developer';

export const ROLE_LABELS: Record<RoleType, string> = {
  admin: 'Admin',
  manager: 'Manager',
  developer: 'Developer',
};

// Options for role selects: [{ value: 'admin', label: 'Admin' }, ...]
export const ROLE_OPTIONS = (Object.keys(ROLE_LABELS) as RoleType[]).map(value => ({
  value,
  label: ROLE_LABELS[value],
}));

export const roleToLabel = (role?: string | null): string =>
  (role && ROLE_LABELS[role as RoleType]) || 'Unknown';
